import MediaLayout from "@/components/common/MediaLayout";
import BaseModule from "@/components/site-builder/BaseModule";
import { SiteBuilderModuleHeaderPosition } from "@/constants/site-builder";
import Player from "./Player";
import { type VideoModuleType } from "./types";

export interface VideoModuleProps {
  module: VideoModuleType;
}

export default function VideoModule(props: VideoModuleProps) {
  const { module } = props;
  const {
    body: { mediaSize },
    style: {
      display: { headerPosition },
    },
  } = module;

  const mediaContent = <Player module={module} />;

  return (
    <BaseModule module={module}>
      {headerPosition === SiteBuilderModuleHeaderPosition.Top ? (
        <MediaLayout size={mediaSize}>{mediaContent}</MediaLayout>
      ) : (
        mediaContent
      )}
    </BaseModule>
  );
}
